import { WORKER_BLOCKS_FETCH_BEGIN } from './action-types'
import type { FetchWorkerBlocksPayload } from './types'

export const fetchWorkerBlocks = (payload: FetchWorkerBlocksPayload) => ({
  type: WORKER_BLOCKS_FETCH_BEGIN as typeof WORKER_BLOCKS_FETCH_BEGIN,
  payload,
})
export type FetchWorkerBlocksAction = ReturnType<typeof fetchWorkerBlocks>
